<div class="runtime-config-container">
  <div class="config-table workflow-config">
    <div class="config-sub-header">
      <strong>Workflow</strong>
    </div>
    <div class="config-prop-container">
      <div class="config-prop-label">
        <label for="workflowConfig">Runtime Workflow</label>
        <i
          class="fa fa-info-circle wf-status-field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'RUNTIME_WORKFLOW_HELP_TEXT' | translate }}"
        ></i>
      </div>
      <div class="config-prop-value">
        <p-checkbox
          id="workflowConfig"
          [(ngModel)]="isRuntimeWorkflowConfigured"
          [binary]="true"
          (onChange)="onRuntimeWorkflowConfigChange($event)"
          [disabled]="disableField"
        ></p-checkbox>
      </div>
    </div>
    <div class="config-prop-container" *ngIf="isRuntimeWorkflowConfigured">
      <div class="config-prop-label">
        <label for="statusField" class="required">Workflow Status Field</label>
        <i
          class="fa fa-info-circle wf-status-field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'WF_STATUS_FIELD_HELP_TXT' | translate }}"
        ></i>
      </div>
      <div class="config-prop-value">
        <div
          class="custom-icon-wrapper"
          [ngClass]="{ 'error-border': errorObj.type === 'error', 'warning-border': errorObj.type === 'warning' }"
        >
          <p-select
            [options]="wfStatusFieldSuggestions"
            [(ngModel)]="selectedWorkflowStatus"
            optionLabel="name"
            placeholder="Select Status Field"
            (onChange)="handleWfStatusFieldChange()"
          ></p-select>
          <i
            class="fa fa-exclamation-circle error-icon1"
            *ngIf="errorObj.type === 'error'"
            (mouseenter)="toggleRuntimeConfigPopup()"
            (mouseleave)="toggleRuntimeConfigPopup()"
          ></i>
          <i
            class="fa fa-exclamation-triangle error-icon1"
            *ngIf="errorObj.type === 'warning'"
            (mouseenter)="toggleRuntimeConfigPopup()"
            (mouseleave)="toggleRuntimeConfigPopup()"
          ></i>
        </div>

        <div class="warning-wrapper">
          <div class="val-err" [ngClass]="{ 'error-popup': errorObj.type === 'error', 'warning-popup': errorObj.type === 'warning' }" *ngIf="showWarningPopup">
            <div class="warning-header">
              <p>{{ errorObj?.type === 'warning' ? 'Warning' : 'Error' }}</p>
              <i class="pi pi-times"></i>
            </div>
            {{ errorObj?.errorMsg }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="config-table business-rules-config mt-2">
    <div class="config-sub-header">
      <strong>Business Rules</strong>
    </div>
    <div class="config-prop-container">
      <div class="config-prop-label">
        <label for="businessRulesConfig">Runtime Business Rules</label>
        <i
          class="fa fa-info-circle wf-status-field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'RUNTIME_BUSINESS_RULES_HELP_TEXT' | translate }}"
        ></i>
      </div>
      <div class="config-prop-value">
        <p-checkbox
          id="businessRulesConfig"
          [(ngModel)]="isRuntimeBusinessRulesConfigured"
          [binary]="true"
          (onChange)="onRuntimeBusinessRulesConfigChange($event)"
          [disabled]="disableField"
        ></p-checkbox>
      </div>
    </div>
    <div class="config-prop-container" *ngIf="isRuntimeBusinessRulesConfigured">
      <div class="config-prop-label">
        <label for="businessRulesEvents">Business Rules Events</label>
        <i
          class="fa fa-info-circle wf-status-field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'BR_EVENTS_HELP_TXT' | translate }}"
        ></i>
      </div>
      <div class="config-prop-value">
        <p-multiSelect
          [options]="businessRuleEvents"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="selectedBusinessRuleEvents"
          [placeholder]="'Select events'"
          id="businessRulesEvents"
          (onChange)="businessRuleEventsDropdownChange$.next($event)"
          [disabled]="disableField"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="top"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          [pTooltip]="businessRuleEventsTooltip"
          [filter]="true"
          filterBy="label"
          [resetFilterOnHide]="true"
        ></p-multiSelect>
      </div>
    </div>
  </div>

  <div class="property-container mt-2" *ngIf="isConfigureBtnEnabled">
    <div class="property-label">
      <label for="configureFieldsBtn">{{ 'RUNTIME_FIELD_SHARING' | translate }}</label>
      <i
        class="fa fa-info-circle rt-field-config-info"
        showDelay="100"
        hideDelay="100"
        tooltipPosition="bottom"
        tooltipStyleClass="label-tooltip custom-tooltip-properties"
        pTooltip="{{ 'RT_FIELD_SHARING_HELP_TXT' | translate }}"
      ></i>
    </div>
    <div class="property-value">
      <div
        class="fields-used-div"
        showDelay="100"
        hideDelay="100"
        tooltipPosition="top"
        tooltipStyleClass="label-tooltip custom-tooltip-properties"
        [pTooltip]="fieldsUsedInConfig.join(', ')"
      >
        {{ fieldsUsedInConfig.join(', ') }}
      </div>
      <div class="config-btn-container">
        <button
          pButton
          id="configureFieldsBtn"
          class="config-btn"
          [disabled]="!pickList"
          (click)="showFieldConfigDialog()"
        >
          {{ 'CONFIGURE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
